// DirectionContext.js
import React, { createContext, useContext, useState, useEffect } from "react";

const AppContext = createContext({ direction: "ltr" });

export const useApp = () => useContext(AppContext);

const AppProvider = ({ children }) => {
  const [direction, _setDirection] = useState("ltr");
  const [language, _setLanguage] = useState("en");

  useEffect(() => {
    const direction = localStorage.getItem("direction");
    setDirection(direction || "ltr");
  }, []);

  const setDirection = (direction) => {
    localStorage.setItem("direction", direction);
    _setDirection(direction);
    document.querySelector('body').style.direction = direction;
  };

  const setLanguage = (lang) => {
    _setLanguage(lang);
    const direction = lang == "ar" ? "rtl" : "ltr";
    setDirection(direction);
  };
  

  return (
    <AppContext.Provider value={{ direction, setLanguage, language }}>
      {children}
    </AppContext.Provider>
  );
};

export default AppProvider;
